import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slide--left",
  "use": "icon-slide--left-usage",
  "viewBox": "0 0 9 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 12\" id=\"icon-slide--left\"><path d=\"M.375 6.217a.25.25 0 0 1 0-.434l8.25-4.763A.25.25 0 0 1 9 1.237v9.526a.25.25 0 0 1-.375.217L.375 6.217Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol